<app-header [showHamburger]="false" logoutRoute="/shared/logout" mobileLogoutRoute="/shared/logout"></app-header>

@if (debug.isDebugVisible()) {
  <app-debug-panel></app-debug-panel>
}

<div class="mb-20 pb-20 app-container overflow-y-auto">
  <router-outlet></router-outlet>
</div>
